var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRankings(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "navIcon",
    width: "21px",
    height: "13px",
    viewBox: "0 0 21 13",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "{t.rankings}") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "navIcon",
    id: "Page-1",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    className: "navIcon",
    id: "Dashboard---Actions",
    transform: "translate(-49.000000, -169.000000)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    className: "navIcon",
    id: "Sidebar",
    transform: "translate(30.000000, 120.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "navIcon",
    id: "sidebar"
  }, /*#__PURE__*/React.createElement("g", {
    className: "navIcon",
    id: "Ranking",
    transform: "translate(19.000000, 46.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "navIcon",
    id: "icon-ranking",
    transform: "translate(0.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    opacity: 0.5,
    points: "5.67832168 9.68114064 2.16783217 11 2.31468531 7.19313027 0 4.19896306 3.59440559 3.16526248 5.67132867 0 7.74825175 3.16526248 8 3.23655217 7.61538462 3.82112767 2.40559441 5.31108231 5.76223776 9.65262476"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "10.5067818 11.6811406 7.10234279 13 7.24475956 9.19313027 5 6.19896306 8.48581998 5.16526248 10.5 2 12.51418 5.16526248 16 6.19896306 13.7552404 9.19313027 13.8976572 13"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    opacity: 0.5,
    points: "18.8453519 11 15.356212 9.68199482 15.2172024 9.66062176 18.5534318 5.32189119 13.3683753 3.81865285 13 3.24870466 13.2988705 3.16321244 15.3631625 0 17.4274544 3.16321244 21 4.19624352 18.6993918 7.1884715"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRankings);
export default __webpack_public_path__ + "static/media/rankings.0a072050.svg";
export { ForwardRef as ReactComponent };